import { useState } from "react";
import "normalize.css";

import { Layout } from "./components/Layout";
import { QuestionsStep, StartStep, SummaryStep } from "./steps";
import { AppContext } from "./App.context";
import { useQuestionsGenerator } from "./helpers/questionsHelper";
import "./App.css";

export const STEPS = {
  START: "START",
  QUESTIONS: "QUESTIONS",
  SUMMARY: "SUMMARY",
};

const App = () => {
  const [step, setStep] = useState(STEPS.START);
  const [postId, setPostId] = useState("");
  const [points, setPoints] = useState(0);
  const [questionsGenerator, questionsCount] = useQuestionsGenerator(postId);

  const changeStep = (newStep) => {
    setStep(newStep);
  };

  const changePostId = (newPostId) => {
    setPostId(newPostId);
  };

  const addPoints = () => {
    setPoints((prev) => (prev += 1));
  };

  return (
    <AppContext.Provider
      value={{
        postId,
        step,
        points,
        questionsCount,
        questionsGenerator,
        changeStep,
        changePostId,
        addPoints,
      }}
    >
      <Layout>
        {step === STEPS.START && <StartStep />}
        {step === STEPS.QUESTIONS && <QuestionsStep />}
        {step === STEPS.SUMMARY && <SummaryStep />}
      </Layout>
    </AppContext.Provider>
  );
};

export default App;
